export default {
  title: 'Métodos de Encomenda',
  paywall: {
    live_title: '{{name}} está no ar!',
  },
  tabs: {
    general: 'Geral',
    pickup: 'Recolha',
    delivery: 'Entrega',
    room_service: 'Serviço de quarto/mesa',
  },
  modals: {
    update_confirmation: {
      title: 'Tem a certeza que pretende guardar as novas alterações?',
      buttons: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Tem a certeza que pretende desativar as encomendas em tempo real?',
        enable: 'Tem a certeza que pretende ativar as encomendas em tempo real?',
      },
      buttons: {
        yes: 'Sim',
        no: 'Não',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
